import { render } from "./LoggedoutHome.vue?vue&type=template&id=6c70e040&scoped=true"
import script from "./LoggedoutHome.vue?vue&type=script&lang=js"
export * from "./LoggedoutHome.vue?vue&type=script&lang=js"

import "./LoggedoutHome.vue?vue&type=style&index=0&id=6c70e040&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c70e040"]])

export default __exports__